import Vue from 'vue';
import Router from 'vue-router';
import OffChainTools from "../components/OffChainTools/OffChainTools";
import OnChainTools from "../components/OnChainTools/OnChainTools";
import NodeTools from "../components/NodeTools/NodeTools";

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/node-tools',
            name: 'node-tools',
            component: NodeTools
        },
        {
            path: '/on-chain-tools',
            name: 'on-chain-tools',
            component: OnChainTools
        },
        {
            path: '/off-chain-tools',
            name: 'off-chain-tools',
            component: OffChainTools
        },
        {
            path: '/',
            redirect: '/off-chain-tools'
        }
    ]
})
